import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const post = (path, data) => axios.post(`${API}${path}`, data);

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const openRazorpay = ({ order, name, email, phone, onSuccess, onDismiss }) => {
  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "Revolutionary Goans Party",
    theme: { color: "#FACC15" },
    prefill: { name, email, contact: phone || "" },
    handler: onSuccess,
    modal: { ondismiss: onDismiss },
  });
  rzp.open();
};

export const ASSETS = {
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_8e0bcb08-3f95-4a5f-a68a-94e4b3b5320b/artifacts/ifbw7obv_799770504_1069267935494980_7511907070870076762_n.jpg",
  poster: "https://customer-assets-gfyr7b9c.emergentagent.net/job_8e0bcb08-3f95-4a5f-a68a-94e4b3b5320b/artifacts/bk9l8ftb_825353281_1085999077155199_7479923504012009252_n.jpg",
};
